module.exports = __webpack_public_path__ + "img/30.2e4f18d5.png";